import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/_services/auth.service';
import { StudentService } from 'src/app/_services/student.service';
import { SyllabusService } from 'src/app/_services/syllabus.service';
import { Subscription } from './../../../_models/subscription';
import { QuizService } from './../../../_services/quiz.service';

import { ResultData } from 'src/app/_models/ResultData';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-lesson-syllabus',
  templateUrl: './lesson-syllabus.component.html',
  styleUrls: ['./lesson-syllabus.component.css']
})
export class LessonSyllabusComponent implements OnInit {
  quizarea_syllabus={topics:[],selectedTopics:[]}
  server_student_user_id=0
  subscription=new Subscription()
  learner:any=undefined
  loading=false
  syllabusinfo:any=undefined
  renderMathNow=false

  flashMessage=""
  constructor(
    public authService:AuthService,
    private studentService:StudentService,
    private quizService:QuizService,
    private syllabusService:SyllabusService
    ) { }

  ngOnInit(): void {

     this.studentService.minStudentData.subscribe(
      data =>{
        this.onAfterUpdate()
            this.learner=data
            this.server_student_user_id = this.learner.server_user_id
            if(this.server_student_user_id!=0){
              this.subscription=this.learner['subscription_object']
            }
        }
    );

  }
  updateQuizAreaItem(subTopicId:number, category:string){

    this.renderMathNow=false
    if(this.subscription.server_subscription_id!=0){
     let x= this.quizService.updateQuizAreaItem(this.subscription.server_subscription_id,subTopicId,category).subscribe(
       data=>{

        if(data.topicSubTopicId!=0){
              this.loadSyllabus()
              this.flashMessage=data['message']
              let bold_yes=data["bold_yes"]
              if(bold_yes==0){
              this.alertOneSubtopic()
              }
        }
      })
    }
  }
  ngAfterViewInit(){
   Promise.resolve(null).then(() => {this.renderMathNow=true})
    }

   onAfterUpdate(){
     Promise.resolve(null).then(() => {
      this.renderMathNow=true
    })

   }

  alertOneSubtopic(){
    Swal.fire("Oops",this.flashMessage,'info')
  }
  loadSyllabus(){
    this.loading=true
    this.syllabusService.getSyllabusInfo(this.server_student_user_id).subscribe({
      next:(data:ResultData)=>{
        this.syllabusinfo=data.rs.data['syllabus']
        this.loading=false
      }
    }

    )
  }
}
